import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Popper from '../Popper/Popper';
import DropdownIcon from './DropdownIcon';
/**
 * A [`Popper`](#/Dialog%20components?id=popper) trigger for
 * the [`Dropdown`](#/Dialog%20components?id=dropdown) component.
 *
 * @since 7.28.0
 */

var DropdownPopper = /*#__PURE__*/styled(Popper).withConfig({
  displayName: "DropdownPopper",
  componentId: "c11n-8-64-0__sc-1vnow1h-0"
})([""]);
DropdownPopper.propTypes = {
  /**
   * The popper content, usually a [`DropdownIcon`](#/Dialog%20components?id=dropdownicon) or a
   * [`DropdownButton`](#/Dialog%20components?id=dropdownbutton).
   */
  children: PropTypes.node,

  /**
   * The [`Popper`](#/Dialog%20components?id=popper) `offset` prop.
   */
  offset: PropTypes.oneOfType([PropTypes.array, PropTypes.func])
};
DropdownPopper.defaultProps = {
  children: /*#__PURE__*/React.createElement(DropdownIcon, null),
  offset: [0, 8]
};
/** @component */

export default DropdownPopper;
export var StyledDropdownPopper = DropdownPopper;